import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import type { UserRole } from '@core/models/user.model';

/**
 * Restrict a route to specific roles. Configure via route data:
 *   { path: 'admin', canActivate: [roleGuard], data: { roles: ['school_admin'] } }
 * Passes if the user holds ANY of the listed roles; otherwise /unauthorized.
 */
export const roleGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = auth.currentUser();
  if (!user) {
    return router.createUrlTree(['/login']);
  }

  const required = (route.data['roles'] as UserRole[] | undefined) ?? [];
  if (required.length === 0) {
    return true;
  }

  const allowed = user.roles.some((r) => required.includes(r));
  return allowed ? true : router.createUrlTree(['/unauthorized']);
};
